<ng-fence-environment *ngIf="step === 1"></ng-fence-environment>
<ng-fence-fence-configuration *ngIf="step === 2"></ng-fence-fence-configuration>
<ng-fence-materials *ngIf="step === 3"></ng-fence-materials>
<ng-fence-accessories *ngIf="step === 4"></ng-fence-accessories>
<ng-fence-summary *ngIf="step === 5"></ng-fence-summary>
